import React from 'react';
import { Box } from '@wds/box';
import { Typography } from '@wds/typography';
import { T, defineMessages } from '@sm/intl';
import { WrenchTheme } from '@wds/styles';

import { useTheme } from 'react-jss';
import useStyles from './useStyles';

// put this into common error component strings file
const COPY = defineMessages({
  SORRY_MESSAGE: {
    id: 'ForbiddenError.sorryMessage',
    defaultMessage: "We're sorry",
    description: '[Type: Label][Vis.: med] - We are sorry message',
  },
  PERMISSIONS: {
    id: 'ForbiddenError.permissions',
    defaultMessage: 'You do not have permission to see this page.',
    description: '[Type: Label][Vis.: med] - We are sorry message',
  },
  CHECK_URL: {
    id: 'ForbiddenError.checkURL',
    defaultMessage:
      "Please check the URL you entered to make sure it's spelled correctly.",
    description: '[Type: Label][Vis.: med] - check URL subtitle',
  },
  HELP_FIND_WAY: {
    id: 'ForbiddenError.helpFindWay',
    defaultMessage:
      'Still not sure how to get to the page you want? Maybe we can help you find your way:',
    description: '[Type: Label][Vis.: med] - Help find your way subtitle',
  },
  HOME: {
    id: 'ForbiddenError.home',
    defaultMessage: 'Home',
    description:
      '[Type: Label][Vis.: med] - Home link in Five Hundred Error Message',
  },
  SITEMAP: {
    id: 'ForbiddenError.sitemap',
    defaultMessage: 'Sitemap',
    description:
      '[Type: Label][Vis.: med] - Sitemap link in Five Hundred Error Message',
  },
  HELP_CENTER: {
    id: 'ForbiddenError.helpCenter',
    defaultMessage: 'Help Center',
    description:
      '[Type: Label][Vis.: med] - Help Center link in Five Hundred Error Message',
  },
  TEMPLATES: {
    id: 'ForbiddenError.templates',
    defaultMessage: 'Templates',
    description:
      '[Type: Label][Vis.: med] - Templates link in Five Hundred Error Message',
  },
  LEARN_MORE: {
    id: 'ForbiddenError.learnMore',
    defaultMessage: 'Learn More',
    description:
      '[Type: Label][Vis.: med] - Learn More link in Five Hundred Error Message',
  },
});

const ForbiddenError = () => {
  const theme: typeof WrenchTheme = useTheme();
  const {
    forbiddenError,
    forbiddenErrorMessageWrapper,
    forbiddenErrorMessageContainer,
    forbiddenErrorLinksContainer,
    forbiddenErrorLinksList,
    forbiddenErrorLinksListItem,
  } = useStyles({ theme });

  return (
    <div className={forbiddenError} data-testid="ForbiddenError">
      <div className={forbiddenErrorMessageWrapper}>
        <Typography align="center" variant="pageTitle">
          <T desc={COPY.SORRY_MESSAGE} />
        </Typography>
        <div className={forbiddenErrorMessageContainer}>
          <Typography align="center" component="section" variant="sectionTitle">
            <Box p={1}>
              <T desc={COPY.PERMISSIONS} />
            </Box>
          </Typography>
          <Typography align="center" component="div" variant="body">
            <Box p={1}>
              <p>
                <T desc={COPY.CHECK_URL} />
              </p>
              <p>
                <T desc={COPY.HELP_FIND_WAY} />
              </p>
            </Box>
          </Typography>
          <div className={forbiddenErrorLinksContainer}>
            <ul className={forbiddenErrorLinksList}>
              <li className={forbiddenErrorLinksListItem}>
                <a href="/">
                  <T desc={COPY.HOME} />
                </a>
              </li>
              <li className={forbiddenErrorLinksListItem}>
                <a href="/mp/sitemap/">
                  <T desc={COPY.SITEMAP} />
                </a>
              </li>
              <li className={forbiddenErrorLinksListItem}>
                <a href="https://help.surveymonkey.com/">
                  <T desc={COPY.HELP_CENTER} />
                </a>
              </li>
              <li className={forbiddenErrorLinksListItem}>
                <a href="/mp/survey-templates/">
                  <T desc={COPY.TEMPLATES} />
                </a>
              </li>
              <li className={forbiddenErrorLinksListItem}>
                <a href="/mp/take-a-tour/">
                  <T desc={COPY.LEARN_MORE} />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForbiddenError;
